import Spotify3 from './Spotify3'
export default Spotify3
